import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import ConfirmationBox from "./ConfirmationBox.tsx";
import UserService from "../services/user.service";
import {
  preserveCalendarItemId,
  restoreCalendarItemId,
} from "../lib/calendar-event.ts";
import type { AppointmentItem } from "../pages/models";

type FreeAppointmentsProps = {
  appointment: AppointmentItem | null;
  show: boolean;
  onHide: () => void;
  newDateChoosen: (appointment: AppointmentItem) => void;
};

const FreeAppointments = ({
  appointment,
  show,
  onHide,
  newDateChoosen,
}: FreeAppointmentsProps) => {
  const [freeAppointments, setFreeAppointments] = useState<AppointmentItem[]>(
    []
  );
  const getFreeAppointments = async () => {
    try {
      const result = await UserService.getFreeAppointments();
      setFreeAppointments(result.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const formatDate = (date: string) => {
    return moment(date).format("LLL");
  };

  const askChangeAppointmentDate = async (newAppointment: AppointmentItem) => {
    if (!appointment) {
      return;
    }

    if (
      await ConfirmationBox(
        `Client: ${appointment.client.clientName}\nFrom: ${formatDate(
          appointment.startDateTime
        )}\nTo: ${formatDate(newAppointment.startDateTime)}`,
        "OK",
        "Cancel",
        {
          title: "Are your sure to change appointment?",
        }
      )
    ) {
      newDateChoosen(newAppointment);
    }
  };

  useEffect(() => {
    if (show) {
      getFreeAppointments();
    }
  }, [show]);

  const formatTitle = (appointmentItem: AppointmentItem) => {
    const hour = moment(appointmentItem.startDateTime).format("h a");
    return appointmentItem.status === "draft"
      ? `${hour}: available`
      : `${hour}: ${appointmentItem.client?.clientName || "Appointment"}`;
  };

  const calendarEvents = freeAppointments.map((freeAppointment) => ({
    ...preserveCalendarItemId(freeAppointment),
    start: freeAppointment.startDateTime,
    end: freeAppointment.endDateTime,
    title: formatTitle(freeAppointment),
    classNames: ["fc-event-status-draft"],
  }));

  return (
    <Modal
      // {...props}
      show={show}
      onHide={onHide}
      size="lg"
      className="appointment-date-picker-modal"
      backdropClassName="appointment-date-picker-backdrop"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Select new data
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="service-calendar p-3">
        <FullCalendar
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            listPlugin,
            interactionPlugin,
          ]}
          initialView="dayGridMonth"
          initialDate={appointment?.startDateTime}
          headerToolbar={{
            left: "prev,today,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,listWeek",
          }}
          height="65vh"
          events={calendarEvents}
          eventClick={(info) =>
            askChangeAppointmentDate(
              restoreCalendarItemId(info.event) as AppointmentItem
            )
          }
        />
      </Modal.Body>
    </Modal>
  );
};

export default FreeAppointments;
